import { call, put, all, takeLatest } from "redux-saga/effects";
import * as api from "constants/api";

import {
    GET_TASK_TEMPLATE_USER_RESPONSE_PENDING,
    GET_TASK_TEMPLATE_USER_RESPONSE,
    SG_GET_TASK_TEMPLATE_USER_RESPONSE,
    DELETE_TASK_TEMPLATE_USER_RESPONSE,
    SG_DELETE_TASK_TEMPLATE_USER_RESPONSE,
    FETCH_TASK_TEMPLATE_USER_RESPONSE,
    SG_FETCH_TASK_TEMPLATE_USER_RESPONSE,
    EDIT_TASK_TEMPLATE_USER_RESPONSE,
    SG_EDIT_TASK_TEMPLATE_USER_RESPONSE,
    ADD_TASK_TEMPLATE_USER_RESPONSE,
    SG_ADD_TASK_TEMPLATE_USER_RESPONSE,
    ALL_ERRORS,
  } from "constants/actions";
  import { handleError } from "./ApiError";

function* loadmethods(action) {
    yield put({ type: GET_TASK_TEMPLATE_USER_RESPONSE_PENDING });

  try {
    const json = yield call(api.GET_TASK_TEMPLATE_USER_RESPONSE, action.payload);
    yield put({ type: GET_TASK_TEMPLATE_USER_RESPONSE, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodLoad() {
  yield takeLatest(SG_GET_TASK_TEMPLATE_USER_RESPONSE, loadmethods);
}

function* fetchmethods(action) {
  yield put({ type: GET_TASK_TEMPLATE_USER_RESPONSE_PENDING });
  try {
    const json = yield call(api.FETCH_TASK_TEMPLATE_USER_RESPONSE, action.payload);
    yield put({ type: FETCH_TASK_TEMPLATE_USER_RESPONSE, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodFetch() {
  yield takeLatest(SG_FETCH_TASK_TEMPLATE_USER_RESPONSE, fetchmethods);
}

function* updatemethods(action) {
  yield put({ type: GET_TASK_TEMPLATE_USER_RESPONSE_PENDING });
  try {
    const json = yield call(api.EDIT_TASK_TEMPLATE_USER_RESPONSE, action.payload);
    yield put({ type: EDIT_TASK_TEMPLATE_USER_RESPONSE, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodUpdate() {
  yield takeLatest(SG_EDIT_TASK_TEMPLATE_USER_RESPONSE, updatemethods);
}


function* addmethods(action) {
  yield put({ type: GET_TASK_TEMPLATE_USER_RESPONSE_PENDING });
  try {
    const json = yield call(api.ADD_TASK_TEMPLATE_USER_RESPONSE, action.payload);
    yield put({ type: ADD_TASK_TEMPLATE_USER_RESPONSE, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodAdd() {
  yield takeLatest(SG_ADD_TASK_TEMPLATE_USER_RESPONSE, addmethods);
}

function* deletemethods(action) {
  yield put({ type: GET_TASK_TEMPLATE_USER_RESPONSE_PENDING });
  try {
    yield call(api.DELETE_TASK_TEMPLATE_USER_RESPONSE, action.payload);
    yield put({ type: DELETE_TASK_TEMPLATE_USER_RESPONSE, payload: action.payload });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodDelete() {
  yield takeLatest(SG_DELETE_TASK_TEMPLATE_USER_RESPONSE, deletemethods);
}


export default function* index() {
  yield all([
    methodLoad(),
    methodFetch(),
    methodUpdate(),
    methodAdd(),
    methodDelete(),
  ]);
}
